import { mergeProps } from '@zag-js/solid';
import { Show } from 'solid-js';
import { ark } from '../factory';
import { usePresenceContext } from '../presence';
import { useComboboxContext } from './use-combobox-context';
export const ComboboxContent = (props) => {
    const api = useComboboxContext();
    const presenceApi = usePresenceContext();
    const mergedProps = mergeProps(() => api().getContentProps(), () => presenceApi().presenceProps, props);
    return (<Show when={!presenceApi().unmounted}>
      <ark.div {...mergedProps}/>
    </Show>);
};
